import React, { useState } from 'react';

import Footer from '../components/Footer';
import Navbar from '../components/Navbar';


import image01 from '../assets/CardsImages/card-5-img/img-61.jpg'
import image02 from '../assets/CardsImages/card-5-img/img-62.jpg'
import image03 from '../assets/CardsImages/card-5-img/img-63.jpg'
import image04 from '../assets/CardsImages/card-5-img/img-64.jpg'
import image05 from '../assets/CardsImages/card-5-img/img-65.jpg'
import image06 from '../assets/CardsImages/card-5-img/img-66.jpg'
import image07 from '../assets/CardsImages/card-5-img/img-67.jpg'
import image08 from '../assets/CardsImages/card-5-img/img-68.jpg'
import image09 from '../assets/CardsImages/card-5-img/img-63.jpg'
import image10 from '../assets/CardsImages/card-5-img/img-70.jpg'
import image11 from '../assets/CardsImages/card-5-img/img-71.jpg'
import image12 from '../assets/CardsImages/card-5-img/img-72.jpg'
import image13 from '../assets/CardsImages/card-5-img/img-73.jpg'
import image14 from '../assets/CardsImages/card-5-img/img-74.jpg'
import image15 from '../assets/CardsImages/card-5-img/img-75.jpg'
import image16 from '../assets/CardsImages/card-5-img/img-61.jpg'

const Card05 = () => {


    
        const [selectedImage, setSelectedImage] = useState(null); // State to hold the currently selected image
    
        const images = [
            image01,
            image02,
            image03,
            image04,
            image05,
            image06,
            image07,
            image08,
            image09,
            image10,
            image11,
            image12,
            image13,
            image14,
            image15,
            image16
    
    
            // Add the rest of the images here...
        ];
    
        const handleImageClick = (image) => {
            setSelectedImage(image); // Set the selected image
        };
    
        const handleClose = () => {
            setSelectedImage(null); // Clear the selected image
        };
    
    
    return (

        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto px-6 py-12 mt-8">
                <h1 className="text-3xl font-bold text-center text-purple-950 mb-8">Maintenance & Inspection of Vessel</h1>
                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">
                    <h2 className="text-2xl font-semibold mb-4">Maintenance & Inspection of Vessel Job</h2>
                    <p className="mb-4">
                        Maintenace & Inspection of vessel, heat exchanger, piping etc. Maintenance and inspection of vessels, heat exchangers, piping, and other process equipment are essential in industrial facilities to ensure safe and efficient operations. Here are the key aspects of maintenance and inspection for these types of equipment.
                    </p>
                    {/* <p className="mb-4">
            Distillation column supervision and inspection jobs are crucial to maintain the reliability, safety, and
            performance of these critical components in various industrial processes.
          </p> */}
                </div>

                <div className="container mx-auto px-4 py-8 my-10">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">1. Vessels (Pressure Vessels, Tanks, etc.):
                                Inspection</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Conduct regular visual inspections to check for external corrosion, leaks, and signs of damage.</li>
                                    <li>Perform non-destructive testing (NDT) to examine the vessel's internal integrity.</li>
                                    <li>Check for pressure relief valve and safety system functionality.</li>
                                    <li>Inspect welds, gaskets, and seals for leaks or wear.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">2. Vessels (Pressure Vessels, Tanks, etc.):
                                Maintenance</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Repair or replace damaged or corroded areas.</li>
                                    <li>Inspect and maintain pressure relief devices, including relief valves and rupture discs.</li>
                                    <li>Perform hydrostatic or pneumatic pressure testing if required.</li>
                                    <li>Keep records of inspections and maintenance activities for regulatory compliance.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">3. Heat Exchangers:
                                Inspection</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Inspect the heat exchanger's tubes, fins, and surfaces for fouling, corrosion, or scaling.</li>
                                    <li>Check for leaks in the tube bundles and the shell.</li>
                                    <li>Use NDT techniques to detect internal issues, such as tube wall thinning or erosion.</li>
                                    <li>Monitor temperature and pressure differentials.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">4. Heat Exchangers: Maintenance</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Clean or descale heat exchanger surfaces as needed.</li>
                                    <li>Replace or repair damaged tubes, gaskets, or other components.</li>
                                    <li>Conduct leak tests and reseal the heat exchanger.</li>
                                    <li>Optimize cleaning schedules and techniques to improve heat transfer efficiency.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">5. Piping: Inspection</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Inspect the external condition of piping for signs of corrosion, leaks, or physical damage.</li>
                                    <li>Use NDT methods to assess the integrity of critical piping components.</li>
                                    <li>Monitor pressure, temperature, and flow rates to detect anomalies.</li>
                                    <li>Check for leaks at flanges, joints, and connections.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">6. Piping: Maintenance </h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Repair or replace corroded or damaged sections of piping.</li>
                                    <li>Perform maintenance on valves, pumps, and other associated equipment.</li>
                                    <li>Conduct leak tests and reseal connections.</li>
                                    <li>Ensure the correct alignment of piping and supports to prevent stress and vibration-related issues.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">7. Other Equipment: Inspection and Maintenance</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>For rotating equipment (e.g., pumps, compressors, agitators), monitor vibration, temperature, and lubrication systems.</li>
                                    <li>For electrical and control systems, check for wear, proper grounding, and electrical safety.</li>
                                    <li>For instrumentation, calibrate and verify the accuracy of sensors and transmitters.</li>
                                    <li>For insulation systems, inspect for damage or deterioration and repair or replace as needed.</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">8. Other Equipment: Safety and Compliance</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Prioritize safety throughout maintenance and inspection activities, following industry regulations and safety standards.</li>
                                    <li>Conduct hazard assessments and implement necessary safeguards.</li>
                                    <li>Ensure all maintenance personnel are trained and equipped with appropriate personal protective equipment (PPE).</li>
                                </ul>
                            </p>
                        </div>

                        <div className="bg-white p-6 rounded-lg shadow-lg">
                            <h2 className="text-2xl font-semibold text-purple-800 mb-4">9. Documentation and Reporting</h2>
                            <p className="text-gray-700">
                                <ul className="list-disc pl-5">
                                    <li>Maintain detailed records of inspection findings and maintenance activities.</li>
                                    <li>Ensure compliance with regulatory reporting requirements.</li>
                                    <li>Use maintenance data to optimize maintenance strategies and asset management.</li>
                                </ul>
                            </p>
                        </div>
                    </div>
                </div>


                <div className="bg-gradient-to-r from-purple-800 to-purple-950 text-white p-6 rounded-lg mb-10">

                    <p className="mb-4">
                    Regular maintenance and inspection of vessels, heat exchangers, piping, and other process equipment are essential to prevent accidents, maintain equipment efficiency, and extend the lifespan of these assets. Adhering to a well-structured maintenance program helps ensure the continued safe and reliable operation of industrial facilities.
                    </p>
                </div>


                {/* All Work Section */}
                <div className="my-12 text-center">
                    <h2 className="text-2xl font-bold text-purple-800 mb-4">All Work</h2>
                    <p className="text-lg text-gray-700 mb-4">We provide high standard work for your Company solutions</p>
                </div>

                {/* Images Section */}
                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                        {images.map((image, index) => (
                            <div
                                key={index}
                                className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
                                onClick={() => handleImageClick(image)} // Set the image on click
                            >
                                <img
                                    src={image}
                                    alt={`Gallery Image ${index + 1}`}
                                    className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300 cursor-pointer"
                                />
                            </div>
                        ))}
                    </div>


                    {/* Modal to show selected image */}
                    {selectedImage && (
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 " >
                            <div className="relative">
                                <img
                                    src={selectedImage}
                                    alt="Selected"
                                    className="max-w-full max-h-screen rounded-lg"
                                />
                                <button
                                    onClick={handleClose}
                                    className="absolute top-2 right-2 text-white bg-red-600 hover:bg-red-700 rounded-full p-2"
                                >
                                    ✖
                                </button>
                            </div>
                        </div>
                    )}
            </div>

            {/* <Footer /> */}
        </div>
    );
};

export default Card05;
